<template>
    <div class="modify_popover">
        <el-button class="modify_button" v-popover:popover :class="{please:btnValue === '请选择'}">{{btnValue}}</el-button>
        <el-popover
                ref="popover"
                v-model="popoverVisible"
                placement="top"
                trigger="click">
            <PopoverInput v-if="popoverType === 'input'" :countType="score" ref="input" title="请输入分值" :defaultValue="dataValue" @close="close" @submit="submit"></PopoverInput>
            <PopoverInput v-if="popoverType === 'order'" :countType="order" ref="order" title="请输入序号" :defaultValue="dataValue" @close="close" @submit="submit"></PopoverInput>
            <PopoverInput v-if="popoverType === 'question'" :countType="question" ref="question" title="请输入题数" :defaultValue="dataValue" @close="close" @submit="submit"></PopoverInput>
            <PopoverSelect v-if="popoverType === 'select'" :type-list="typeList" ref="select" title="请选择题型" :defaultValue="dataValue" @close="close" @submit="submit"></PopoverSelect>
        </el-popover>
    </div>
</template>

<script>
    export default {
        name: "ModifyPopover",
        components: {
            PopoverInput: () => import('./PopoverInput.vue'),
            PopoverSelect: () => import('./PopoverSelect.vue'),
        },
        data () {
            return {
                popoverVisible: false,
                score:'score',
                order:'order',
                question:'question'
            }
        },
        computed: {
            btnValue () {
                if (this.dataValue) {
                    if (this.popoverType === 'select') {
                        let text;
                        this.typeList.every(item => {
                            if (item.id === this.dataValue) {
                                text = item.name;
                                return false
                            } else {
                                text = '请选择'
                            }
                            return true
                        });
                        return text
                    }
                    if (this.popoverType === 'input') {
                        if(this.dataValue === '0' || this.dataValue === '0.0' || this.dataValue === '0.00') {
                            return  '请选择'
                        } else {
                            return this.dataValue
                        }
                    }
                    return this.dataValue;
                }
                return this.popoverType === 'select' ? '请选择' : '请输入';
            }
        },
        props: {
            popoverType: {
                type: String,
                default: 'input'
            },
            dataValue: {
                type: String,
                default: ''
            },
            // 题型列表
            typeList: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        watch: {
            popoverVisible (newV) {
                if (newV) {
                    if (this.popoverType === 'input') {
                        this.$refs.input.input = this.dataValue
                    }
                    if (this.popoverType === 'select') {
                        this.$refs.select.selectValue = ''
                    }
                    if (this.popoverType === 'order') {
                        this.$refs.order.selectValue = this.dataValue
                    }if (this.popoverType === 'question') {
                        this.$refs.question.selectValue = this.dataValue
                    }
                }
            }
        },
        methods: {
            close () {
                this.popoverVisible = false;
            },
            submit (value) {
                if (value === this.dataValue) {
                    this.popoverVisible = false;
                    return
                }
                this.$emit('submit', {
                    value: value,
                    close: this.close
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modify_popover{
        display: inline-block;
        .modify_button{
            padding: 0;
            width: auto;
            height: auto;
            border: none;
            color: #FFAB00;
            border-bottom: 1px dashed #FFAB00;
        }
        .modify_button:hover{
            background: none;
            opacity: 1;
        }
        .modify_button:active{
            background: none;
        }
        .modify_button:focus{
            background: none;
        }
        .please{
            color: #FB6754;
            border-bottom: 1px dashed #FB6754;
        }
    }
</style>
